<template>
  <div id="app">
    <el-aside width="208px" v-if="!isLogin">
      <div class="logo">
        <img src="/static/images/logo.png" class="login-logo">
      </div>
      <el-menu :default-active="defaultActive" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" @select="handleSelect" background-color="#001529" text-color="#fff" active-text-color="#fff">
        <template v-for="submenu in submenuData">
          <el-menu-item :index="submenu.key" :key="submenu.key" v-if="!submenu.child">
            <i class="el-icon-menu"></i>
            <span slot="title">{{submenu.name}}</span>
          </el-menu-item>
          <el-submenu :key="submenu.key" :index="submenu.key" v-if="(defaultMenuIds.includes(submenu.key) || submenu.isHide)&&submenu.child">
            <template slot="title">
              <i class="iconfont" :class="submenu.icon"></i>
              <span>{{submenu.name}}</span>
            </template>
            <el-menu-item-group>
              <template v-for="menu in submenu.child">
                <el-menu-item :key="menu.key" :index="menu.key" v-if="defaultMenuIds.includes(submenu.key) || menu.isHide || menu.moduleId == -1">{{menu.name}}</el-menu-item>
              </template>
            </el-menu-item-group>
          </el-submenu>
        </template>
      </el-menu>
    </el-aside>
    <header v-if="!isLogin">
      <span class="title">中央控制台</span>
      <div class="right">
        <span>欢迎你！</span>
        <img src="../static/images/user.png" class="user-logo">
        <span class="name">{{userName}}</span>
        <router-link to="/" tag="a" class="exit" name="Login">
          <i class="iconfont icon-exit"></i>
          <span>退出</span>
        </router-link>
      </div>
    </header>
    <div class="page-main">
      <router-view class="container"/>
    </div>
  </div>
</template>

<script>
import {HTTPServer} from '@/common/js/ajax.js'
// import tool from '@/common/js/tool.js'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'App',
  data () {
    return {
      isLogin: true,
      userName: '',
      defaultActive: 'Formal',
      defaultMenuIds: ['8', '12'],
      submenuData: [
        {'key': '1', 'name': '客户管理', 'icon': 'icon-nav-customer', 'child': [{'moduleId': 2, 'key': 'Formal', 'name': '正式客户'}, {'moduleId': 1, 'key': 'Trial', 'name': '试用客户'}, {'moduleId': 0, 'key': 'Register', 'name': '注册客户'}, {'moduleId': 18, 'key': 'TreeTrial', 'name': '免审设置'}]},
        {'key': '2', 'name': '业务管理', 'icon': 'icon-nav-business', 'child': [{'moduleId': 3, 'key': 'Additional', 'name': '增购'}, {'moduleId': 4, 'key': 'Reduction', 'name': '减购'}, {'moduleId': 5, 'key': 'Renewal', 'name': '续费'}, {'moduleId': 6, 'key': 'InviteCode', 'name': '邀请码'}, {'moduleId': 7, 'key': 'Strategy', 'name': '收费策略'}, {'moduleId': 17, 'key': 'Component', 'name': '组件管理'}, {'moduleId': -1, 'key': 'ThirdParty', 'name': '第三方对照表'}, {'moduleId': 21, 'key': 'RenewOrder', 'name': '续费订单'}]},
        {'key': '3', 'name': '应用管理', 'icon': 'icon-nav-application', 'child': [{'moduleId': 8, 'key': 'PublishedApply', 'name': '已发布应用'}, {'moduleId': 9, 'key': 'AuthstrApply', 'name': '待发布应用'}, {'moduleId': 10, 'key': 'HotApply', 'name': '热门应用'}, {'moduleId': -1, 'key': 'ApplyType', 'name': '分类'}, {'moduleId': 20, 'key': 'ChargeBill', 'name': '收费信息'}, {'moduleId': -1, 'key': 'Authorization', 'name': '授权码'}]},
        {'key': '10', 'name': '发布管理', 'icon': 'icon-nav-application', 'child': [{'moduleId': 19, 'key': 'PlatformMessage', 'name': '发布平台消息'}]},
        {'key': '4', 'name': '新闻中心', 'icon': 'icon-nav-news', 'child': [{'moduleId': 15, 'key': 'NewsManage', 'name': '新闻管理'}, {'moduleId': 15, 'key': 'newsSort', 'name': '新闻分类'}]},
        {'key': '5', 'name': '帮助中心', 'icon': 'icon-nav-help', 'child': [{'moduleId': 16, 'key': 'helpDocument', 'name': '帮助文档'}, {'moduleId': 16, 'key': 'vedioTeach', 'name': '视频教程'}, {'moduleId': 16, 'key': 'caseExplain', 'name': '案例详解'}, {'moduleId': 16, 'key': 'FAQ', 'name': '常见问题'}, {'moduleId': 16, 'key': 'updateLog', 'name': '更新日志'}]},
        {'key': '9', 'name': '监测管理', 'icon': 'iconfont icon-nav-help', 'child': [{'moduleId': -1, 'key': 'LocalMonitor', 'name': '本地监测'}, {'moduleId': 22, 'key': 'OperationManage', 'name': '运营管理'}]},
        {'key': '6', 'name': '平台管理', 'icon': 'icon-nav-platform', 'child': [{'moduleId': 11, 'key': 'Account', 'name': '账号管理'}, {'moduleId': 12, 'key': 'Role', 'name': '角色权限'}, {'moduleId': 13, 'key': 'Password', 'name': '修改密码'}, {'moduleId': 14, 'key': 'PlatLog', 'name': '操作日志'}]},
        {'key': '7', 'name': '运营指标分析', 'icon': 'icon-nav-operate', 'child': [{'moduleId': 30, 'key': 'a1', 'name': '账号统计'}, {'moduleId': 31, 'key': 'a2', 'name': '应用分析'}]},
        {'key': '8', 'name': 'APP版本', 'icon': 'iconfont icon-nav-help', 'child': [{'moduleId': -1, 'key': 'Android', 'name': 'Android版本更新'}]},
        {'key': '11', 'name': '小程序', 'icon': 'iconfont icon-business', 'child': [{'moduleId': -1, 'key': 'Business', 'name': '名片'}]}
      ]
    }
  },
  watch: {
    // 监听路由变化
    $route (to, from) {
      console.log(to, from)
      this.isLogin = (this.$route.name === 'Login' || this.$route.name === 'Add' || this.$route.name === 'Detail')
      if (!this.isLogin) {
        this.queryRoleAuth()
        this.initPage(to, from)
      }
    }
  },
  created () {
  },
  /* 页面加载后执行 */
  mounted () {
    this.isLogin = (this.$route.name === 'Login' || this.$route.name === 'Add' || this.$route.name === 'Detail')
    if (!this.isLogin) {
      this.queryRoleAuth()
      this.initPage()
    }
  },
  methods: {
    queryRoleAuth (type) {
      var jsondata = {'roleId': (JSON.parse(sessionStorage.getItem('userInfo'))).role_id}
      HTTPServer.queryRoleAuth(jsondata, '').then((res) => {
        let b = false
        let obj = {}
        let isrole = true
        this.submenuData.map((item, index) => {
          item.isHide = false
          var num = 0
          item.child && item.child.map((menu, i) => {
            if (menu.key === 'ThirdParty') { // 第三方对照表 管理员才有权限
              menu.moduleId = parseInt(jsondata.roleId) === 1 ? -1 : ''
            }
            item.child[i].isHide = false
            var contains = res.find(v => {
              return v.moduleId === menu.moduleId || menu.moduleId === -1
            })
            if (contains) {
              num++
              item.child[i].isHide = true
              if (!b) {
                b = true
                obj = menu
              }
            }
            if (!menu.isHide && menu.key === this.$route.name && menu.moduleId !== -1) { // 后期版本权限加上将去除
              isrole = false
            }
          })
          item.isHide = (num > 0)
          this.$set(this.submenuData, index, item)
        })
        if (!isrole) {
          this.$router.push({name: obj.key})
        }
        this.setPermissionData(res) // 更新 vuex权限
      })
      console.log(111, this.submenuData)
    },
    initPage (to, from) {
      let userInfo = sessionStorage.getItem('userInfo')
      let requestHeader = sessionStorage.getItem('requestHeader')
      if (this.$route.name !== 'Login' && (!userInfo || !requestHeader)) {
        this.$router.push({ path: '/' })
        return
      }
      this.userName = (JSON.parse(userInfo)).user_name
      this.defaultActive = this.$route.name
      to = to || this.$route
      from = from || {}
      if (to.name === 'ApplyDetail') {
        if (from.name) {
          this.defaultActive = from.name
          sessionStorage.setItem('prepage', from.name)
        } else {
          this.defaultActive = from.name || sessionStorage.getItem('prepage')
        }
      } else {

      }
    },
    handleOpen (key, keyPath) {
    },
    handleClose (key, keyPath) {
    },
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
      this.$router.push({name: key})
    },
    ...mapMutations({
      setPermissionData: 'PERMISSION', // 所有权限表
      setCurrentPermission: 'CURRENT_PERMISSION' // 当前模块权限
    })
  },
  computed: {
    ...mapState({
      permissionData: state => state.permission.permissionData, // 所有权限表
      currentPermission: state => state.permission.currentPermission // 当前模块权限
    })
  }
}
</script>

<style lang="scss">
@import '../static/css/style.scss';
#app{
  height: 100%;
  >.el-aside{
    height: 100%;
    background: #001529;
    float: left;
    overflow-x: hidden;
    .el-menu{
      border-right: none;
      height: calc(100% - 60px);
      overflow: hidden;
      overflow-y: auto;
    }
    .el-menu-item{
      width: 208px;
      color: #fff;
      opacity: 0.5;
      padding-left: 48px!important;
      height: 50px;
      line-height: 50px;
    }
    .el-menu-item.is-active, .el-menu-item:hover{
      opacity: 1;
      color: #fff;
    }
    .el-submenu{
      width: 208px;
    }
    .el-submenu.is-active .el-submenu__title{
      opacity: 1;
      background: #1890FF!important;
    }
    .el-submenu.is-active i, .el-submenu .el-submenu__title:hover, .el-submenu .el-submenu__title:hover i{
      opacity: 1;
      color: #fff;
    }
    .el-menu-item-group__title{
      display: none;
    }
    .el-submenu__title{
      color: #fff;
      opacity: 0.5;
      height: 50px;
      line-height: 50px;
      .iconfont{
        vertical-align: middle;
        margin-right: 5px;
        width: 24px;
        text-align: center;
        font-size: 18px;
        color: #fff;
      }
    }
  }
  .el-aside + header{
    background: #fff;
    box-shadow: 0 1px 4px 0 rgba(0,21,41,0.12);
    width: calc(100% - 208px);
    height: 60px;
    line-height: 60px;
    margin-left: 208px;
    padding: 0 20px;
    .title{
      font-size: 16px;
      color: #000000;
    }
    .right{
      float: right;
      font-size: 14px;
      color: #474D54;
      img{
        width: 30px;
        height: 30px;
        margin: 0 5px;
      }
      .name{
        color: #75808B;
      }
      .exit{
        color: #75808B;
        float: right;
        margin: 0 0 0 20px;
        .iconfont{
          margin-right: 2px;
        }
      }
      .exit:hover{
        color: #409EFF;
      }
    }
  }
  .page-main{
    height: 100%;
  }
  header + .page-main{
    margin-left: 208px;
    height: calc(100% - 60px);
    padding: 15px 15px 0;
    background: #F0F2F5;
    .container{
      background: #fff;
      height: 100%;
      >header{
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #0062B1;
        padding-left: 20px;
        .title{
          font-size: 16px;
          color: rgba(0,0,0,0.65);
        }
        .right{
          float: right;
          padding-right: 15px;
        }
        .seach{
          width: 290px;
        }
        .el-select {
          width: 180px;
          line-height: 1;
        }
        .el-button{
          padding: 8px 15px;
          float: right;
          margin: 15px 0 0 15px;
        }
        .el-dropdown{
          float: right;
          margin: 15px 0 0 15px;
          .el-button{
            padding: 8px 15px;
            float: right;
            margin: 0;
          }
        }
      }
    }
  }
  .logo{
    height: 60px;
    // background: #002140;
    // box-shadow: 0 0 6px 0 rgba(0,21,41,0.35);
  }
  .el-pagination{
    text-align: right;
    padding: 16px 30px 0 0;
  }
  .el-pagination::before, .el-pagination::after{
    display: none;
  }
  .dialog-manage{
    .el-dialog{
      width: 500px;
    }
    .el-dialog__header{
      padding: 13px 20px;
      box-shadow: inset 0 -1px 0 0 #E5E5E5;
    }
    .el-dialog__headerbtn{
      top: 14px;
      .el-dialog__close{
        font-size: 24px;
      }
    }
    .el-dialog__body{
      padding: 30px 40px 28px 20px;
      min-height: 120px;
      .c-item{
        display: flex;
        .title{
          float: left;
          width: 80px;
          text-align: right;
          line-height: 36px;
          font-size: 14px;
          color: #666;
          margin-right: 20px;
          &.must::before{
            content: "*";
            float: right;
            color: #FF1717;
            font-size: 12px;
          }
        }
        .right{
          flex: 1;
          display: inline-block;
          >.el-select{
            width: 100%;
          }
          >.el-input{
            width: 100%;
          }
        }
      }
      .note{
        font-size: 12px;
        color: #FF1717;
        margin-top: 10px;
      }
    }
    .el-dialog__footer{
      padding: 10px 20px;
      box-shadow: inset 0 1px 0 0 #E5E5E5;
      .el-button{
        padding: 8px 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue